// extracted by css-extract-rspack-plugin
export default {"itemIcon":"itemIcon-XLqyQB","topBorder":"topBorder-liAMcc"};